import {
  Box,
  Button,
  Modal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";

import { useAppSelector, useAppDispatch } from "../../../app/hook";
import { dismissSearchModal } from "./search-modal-slice";

/*
 * テーブルモーダル
 */
const SearchModal = () => {
  const {
    visible,
    title,
    positiveBtn,
    negativeBtn,
    searchArea,
    resultArea,
    selectedItems,
    positiveFn,
    dismissFn,
  } = useAppSelector((state) => state.searchModal);
  const dispatch = useAppDispatch();

  /**
   * ポジティブボタンを押下するイベント関数
   */
  const onClickPositiveBtnHandler = () => {
    positiveFn(selectedItems);
    onDismissHandler();
  };

  /**
   * モーダルクローズ関数
   * @returns void
   */
  const onDismissHandler = () => {
    if (dismissFn) {
      dismissFn();
    }
    dispatch(dismissSearchModal());
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onDismissHandler}
      closeAriaLabel="Close modal"
      size="large"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal" onClick={onDismissHandler}>
              {negativeBtn}
            </Button>
            <Button variant="primary" onClick={onClickPositiveBtnHandler}>
              {positiveBtn}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={title}
    >
      <SpaceBetween direction="vertical" size="xs">
        {searchArea}
        {resultArea}
      </SpaceBetween>
    </Modal>
  );
};

export default SearchModal;
